import { LinearProgress } from '@hyperflake/react-ui-library';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import UpdateSiteRecceForm from 'modules/site-recce/components/UpdateSiteRecceForm/UpdateSiteRecceForm';
import useSiteRecceData from 'modules/site-recce/hooks/useSiteRecceData';

import { useParams } from 'react-router-dom';

const UpdateSiteReccePage = () => {
    const { clientInstallationId, projectInstallationId, siteRecceId } = useParams();
    const {
        siteRecce: initialData,
        isLoading,
        setData,
    } = useSiteRecceData(clientInstallationId!, projectInstallationId!, siteRecceId);
    return (
        <>
            {isLoading ? (
                <LinearProgress />
            ) : (
                <PageTemplate>
                    <PageHeading>Update Site Recce</PageHeading>
                    <UpdateSiteRecceForm
                        clientInstallationId={clientInstallationId}
                        projectInstallationId={projectInstallationId}
                        initialData={initialData}
                        setData={setData}
                    />
                </PageTemplate>
            )}
        </>
    );
};

export default UpdateSiteReccePage;
